import { render, staticRenderFns } from "./VirtualShopContent.vue?vue&type=template&id=39189cd0&scoped=true"
import script from "./VirtualShopContent.vue?vue&type=script&lang=ts"
export * from "./VirtualShopContent.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopContent.vue?vue&type=style&index=0&id=39189cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39189cd0",
  null
  
)

export default component.exports